<script lang="ts">
  import logo from "../../assets/Images/logo.png";
</script>

<section>
  <div class="logo-container">
    <img class="logo" src={logo} alt="">
  </div>
</section>


<style lang="scss">

@media only screen and (min-width: 0px) {
  section {
    background-position: 7%;
  }

  .logo-container {
    padding-top: 2rem;
  }

  img {
    width: 12rem;
  }
}
@media only screen and (min-width: 600px) {
  .logo-container {
    padding-top: 4rem;
  }
}
@media only screen and (min-width: 1280px) {
  section {
    background-position: bottom;
  }

  img {
    width: 17rem;
  }
}
@media only screen and (min-width: 1400px) {
}
@media only screen and (min-width: 1920px) {
  .logo-container {
    padding-top: 8rem;
  }
}
@media only screen and (min-width: 2000px) {
}

  section {
    position: relative;
    height: 100vh;
    max-height: 100vh;
    background-image: url('../../assets/Images/bg.jpg');
    background-size: cover;
  }

  .logo-container {
    display: flex;
    justify-content: center;
  }
</style>
